// Web Audio decode runs on the main thread; long files freeze low-RAM tabs.
// Cap by duration tier (deviceMemory rounded to nearest power of 2 by spec —
// undisclosed on Firefox/Safari, treated as the conservative tier).
// p.s. no matter if device has 8 or more ram, the returned max value is 8
export const getLimitsPerDevice = (): {
  sizeLimit: number
  durationLimit: number
} => {
  const memGB = (navigator as Navigator & { deviceMemory?: number })
    .deviceMemory
  if (memGB === undefined)
    return { durationLimit: 15 * 60, sizeLimit: 15 * 1024 * 1024 }
  if (memGB <= 4) return { durationLimit: 15 * 60, sizeLimit: 15 * 1024 * 1024 }
  if (memGB <= 6) return { durationLimit: 20 * 60, sizeLimit: 30 * 1024 * 1024 }
  return { durationLimit: 30 * 60, sizeLimit: 50 * 1024 * 1024 }
}
